import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useSelectedContext } from './SelectedContext';
import './style/ProgressWindow.css';

const ProgressWindow = ({ itemList }) => {

    const { setExtractmin, showExtractProgress, extractMin, setExtractProgressVis } = useSelectedContext();
    const [visible, setVisible] = useState(false);
    const [allDone, setAllDone] = useState(false);

    useEffect(() => {
        const allItemsDone = itemList.every(item => item.extractionFailed || item.extractionComplete);
        setAllDone(allItemsDone);
    }, [itemList]);

    const renderItemStatus = (item) => {
        if (!item.extractionComplete && !item.extractionFailed) {
            return <p>Extracting attributes</p>;
        } 
        if (!item.extractionComplete && item.extractionFailed) {
            return <p style={{ color: 'red' }}>Extraction failed</p>;
        }
        return <p>Extraction complete</p>;
    };

    const renderItemIcon = (item) => {
        if (!item.extractionComplete && !item.extractionFailed) {
            return <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }}></i>;
        } 
        if (!item.extractionComplete && item.extractionFailed) {
            return (
                <div className='info-icon' onClick={() => { setVisible(true); setExtractmin(true); }}>
                    <i className="pi pi-exclamation-circle" style={{ fontSize: '1rem' }}></i>
                </div>
            );
        }
        return <i className="pi pi-check-circle" style={{ fontSize: '1rem' }}></i>;
    };

    return (
        <div 
            className={`import-status-window ${showExtractProgress ? (extractMin ? 'import-status-window-min' : '') : 'import-status-window-hidden'}`}
            style={{ right: '0' }}
        >
            <div className='import-status-content'>
                <div id='import-status-header'>
                    <p>Extracting documents</p>
                    <div id='progress-buttons'>
                        {allDone && 
                            <Button icon="pi pi-times" rounded text onClick={() => setExtractProgressVis(false)} />
                        }
                        <Button 
                            icon={extractMin ? "pi pi-angle-up" : "pi pi-angle-down"} 
                            rounded 
                            text 
                            onClick={() => setExtractmin(!extractMin)} 
                        />
                    </div>
                </div>
                <div id='import-list' className="import-list-scroll">
                    {itemList.map((item, index) => (
                        <div key={index} className='progress-list-item'>
                            <div className='progress-list-item-left-scan'>
                                <div className='progress-list-item-left-scan-progress'>
                                    {renderItemStatus(item)}
                                </div>
                                <div>
                                    <b style={{ color: '#043d75' }}>{item.name}</b>
                                </div>
                            </div>
                            <div className='progress-list-item-right'>
                                {renderItemIcon(item)}
                            </div>
                        </div>
                    ))}
                </div>
                <Dialog header="Extraction Failed" visible={visible} style={{ width: '35vw' }} onHide={() => setVisible(false)}>
                    <p>To attempt extraction again, please re-upload this document.</p>
                    <h3>Important Tips:</h3>
                    <ul>
                        <li>Ensure that the document is clear and of high quality.</li>
                        <li>Avoid uploading blurry documents.</li>
                    </ul>
                    <h3>Need Further Assistance?</h3>
                    <p>If extraction issues persist, kindly create a support ticket on the help page. We're here to assist you!</p>
                </Dialog>
            </div>
        </div>
    );
};

export default ProgressWindow;
